module.exports = __webpack_public_path__ + "img/d- (19).cf025798.png";